
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 20.963a8.963 8.963 0 00.19-17.924L12 3.037A8.963 8.963 0 003.037 12a1 1 0 002 0A6.963 6.963 0 0112 5.037l.148.001A6.963 6.963 0 0112 18.963a1 1 0 000 2z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    